export const baseUrl = 'https://sport.kyivcity.gov.ua/back/api/v1'
